import React, { useState, Fragment, useEffect } from "react";
import { useFormik } from "formik";
import { Button } from "primereact/button";
import { AutoComplete } from "primereact/autocomplete";
import { classNames } from "primereact/utils";

const ShareLinkForm = ({ save, onClose, allUsersEmail, user, mailIdListProp }) => {
    const [filteredName, setFilteredName] = useState(null);

    const actionBtn = {
        border: '1px solid',
        padding: '6px',
        borderRadius: '50%',
        margin: '1px'
    }

    const formik = useFormik({
        initialValues: {
            email: null,
        },
        validate: (data) => {
            let errors = {};
            if (!data.email) {
                errors.email = "Email is required.";
            }
            return errors;
        },
        onSubmit: (data) => {
            save(data);
        },
    });

    const isFormFieldValid = (name) =>
        !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{formik.errors[name]}</small>
            )
        );
    };

    const sendEmail = () => {
        let emailIdList = [];
        formik.values.email.map((el) => {
            emailIdList.push(el.email)
        })
        mailIdListProp(emailIdList)

    }

    const SearchName = (event) => {
        setTimeout(() => {
            let _filteredName;
            if (!event.query.trim().length) {
                _filteredName = [...allUsersEmail];
            }
            else {
                _filteredName = allUsersEmail.filter((p) => {
                    return p.email.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }
            setFilteredName(_filteredName);
        }, 250);
    };

    const onCloseMethod = () => {
        onClose();
    };

    const myForm = (
        <React.Fragment>
            <form
                onSubmit={formik.handleSubmit}
                className="p-fluid p-grid"
                autoComplete="off"
            >
                <div className='mb-2'>
                    <span style={{ textTransform: 'capitalize' }}>{user.firstName} {user.lastName}</span> Profile PDF
                </div>
                <div className='grid'>
                    <div className='col mb-2 mt-2'>
                        <i className="pi pi-file-pdf mr-2" style={{ color: '#f3023a' }}></i>
                        People in Espire Infolabs Pvt. Ltd. with the link can view
                    </div>
                </div>

                <span className="p-fluid">
                    <AutoComplete
                        value={formik.values.email}
                        suggestions={filteredName}
                        completeMethod={SearchName}
                        field="email"
                        virtualScrollerOptions={{ itemSize: 38 }}
                        name="email"
                        multiple
                        onChange={formik.handleChange}
                        placeholder="To : Name or Email"
                        aria-label="Email"
                        dropdownAriaLabel="Select Email"
                        className={classNames({ 'p-invalid': isFormFieldValid('email') })}
                    />
                    {getFormErrorMessage("email")}
                </span>

                <div className='pt-3'>
                    <div className='grid' style={{ float: 'right' }}>
                        <div className='mr-2 mt-1'>
                            <Button
                                type="button"
                                label="Cancel"
                                className="p-button-rounded p-button-secondary"
                                onClick={(e) => onCloseMethod(e)}
                            />
                        </div>
                        <div className='mt-1'>
                            <Button
                                type="submit"
                                label="Share"
                                className="p-button-rounded"
                                onClick={sendEmail}
                            />
                        </div>
                    </div>
                </div>
            </form>
        </React.Fragment>
    );

    return <React.Fragment>{myForm}</React.Fragment>;
};

export default ShareLinkForm;